import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import { useQuery } from 'urql';
import { CollectionComponent } from '../collection/CollectionComponent';
import { getCollections, getCollectionSansSwatches } from './queries';
import css from './Collection.module.scss';
import CollectionLoading from '../../components/CollectionLoading';
import CollectionSet from './CollectionSet';
import RecommendationsAI from '../../components/RecommendationsAI';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CollectionLoader = function CollectionLoader(_ref) {
  var displaySwatches = _ref.displaySwatches,
      shopifyId = _ref.shopifyId;

  var _useQuery = useQuery({
    query: displaySwatches ? getCollections : getCollectionSansSwatches,
    variables: {
      shopifyId: shopifyId
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching;

  if (fetching) {
    return /*#__PURE__*/_jsx(CollectionLoading, {});
  }

  var collection = data.collection;
  var productSets = collection.productSets,
      properties = collection.properties;
  var bottomComponent = properties.bottomComponent,
      footerComponent = properties.footerComponent,
      gridDisplayEditorial = properties.gridDisplayEditorial,
      gridDisplaySwatches = properties.gridDisplaySwatches,
      headerComponent = properties.headerComponent,
      recommendation = properties.recommendation; // If we are not requesting the colorways, set the faceout color

  if (!gridDisplaySwatches) {
    productSets.forEach(function (productSet) {
      productSet.products.edges.forEach(function (_ref2) {
        var _ref2$node = _ref2.node,
            component = _ref2$node.component,
            product = _ref2$node.product,
            faceout = _ref2$node.faceout;

        if (component) {
          return;
        }
        /* eslint-disable no-param-reassign */


        product.colorways = {
          edges: [{
            node: faceout
          }]
        };
      });
    });
  }

  if (gridDisplayEditorial) {
    // Loop through all of the images and see if there is an editorial match. If there is, swap the images
    productSets.forEach(function (_ref3) {
      var edges = _ref3.products.edges;
      return edges.forEach(function (_ref4) {
        var product = _ref4.node.product;
        product === null || product === void 0 ? void 0 : product.colorways.edges.forEach(function (_ref5) {
          var node = _ref5.node;

          if (node.assets.edges.length > 1 && node.assets.edges[1].node.isEditorial) {
            node.image = node.assets.edges[1].node.image;
          }
        });
      });
    });
  }

  var collectionProps = {
    collection: collection,
    productSets: productSets
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [headerComponent && /*#__PURE__*/_jsx("div", {
      className: css.component,
      children: /*#__PURE__*/_jsx(CollectionComponent, {
        component: headerComponent,
        collectionId: collection.id
      })
    }), /*#__PURE__*/_jsx(CollectionSet, _objectSpread({}, collectionProps)), bottomComponent && /*#__PURE__*/_jsx("div", {
      className: css.component,
      children: /*#__PURE__*/_jsx(CollectionComponent, {
        component: bottomComponent,
        collectionId: collection.id
      })
    }), footerComponent && /*#__PURE__*/_jsx("div", {
      className: css.component,
      children: /*#__PURE__*/_jsx(CollectionComponent, {
        component: footerComponent,
        collectionId: collection.id
      })
    }), recommendation && /*#__PURE__*/_jsx(RecommendationsAI, _objectSpread({}, recommendation))]
  });
};

CollectionLoader.defaultProps = {
  banner: {
    component: 'TEXT_ONLY'
  },
  paletteParam: '',
  shopifyId: ''
};
CollectionLoader.propTypes = {
  banner: PropTypes.shape(),
  displaySwatches: PropTypes.bool.isRequired,
  paletteParam: PropTypes.string,
  shopifyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default CollectionLoader;